<template>
  <div class="p-2">
    <div class="row">
      <div class="col-12">
        <h3>Título do filtro</h3>
        <b-form-input v-model="newFilter.name" placeholder=""></b-form-input>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label>Data inicial </label>
        <b-form-input v-model="newFilter.start" type="date" placeholder=""></b-form-input>
      </div>
      <div class="col-6">
        <label>Data final </label>
        <b-form-input v-model="newFilter.end" type="date" placeholder=""></b-form-input>
      </div>    
    </div>
    <div
      style="
        background: #ffffff;
        position: sticky;
        right: 0;
        bottom: -20px;
        padding-top: 20px;
        padding-bottom: 20px;
      "
      class="text-right"
    >
      <b-button @click="saveFilter" variant="primary">Salvar</b-button>
    </div>
  </div>
</template>

<script>
import IdxCard from '@/components/molecules/idx-card';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import swal from 'sweetalert';
import api from '../../../services/api';

export default {
  components: { IdxCard, idxSkeleton },

  props: {
    filters: { type: Array},
  }, 

  data() {
    return {
      newFilter: {
        name: null,
        start: null,
        end: null,
      },
    };
  },
  methods: {
    async saveFilter() {
      if (this.newFilter.name !== '' && this.newFilter.start && this.newFilter.end) {
        try {
          this.filters.push(this.newFilter);
          await api.put(
            `/company/custom-filters/${this.userAuth.companyId}`,
            {
              customFilters: this.filters,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal('Sucesso', 'Filtro personalizado criado com sucesso!', 'success');
          this.$bvModal.hide('modal-add');
        } catch (error) {
          window.console.log(error);
        }
      }
    },
  },
  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

};
</script>

<style scoped>
h3 {
  font-size: 90%;
  font-weight: bold;
}
label {
  font-size: 80%;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}
.btn {
  box-shadow: none !important;
}
.action-list-item {
  padding: 8px;
  border-bottom: solid 1px #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/custom-filter-date/add.vue